import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { interactionsActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: null
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchInteractions, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchInteractions({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
    return true
  }

  componentDidMount() {
    const { fetchInteractions } = this.props
    fetchInteractions()
  }

  handleParsingString(term) {
    var str = term.join(', ')
    return str
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchInteractions, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchInteractions, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = interaction => {
    const {
      fetchInteraction,
      deleteInteraction,
      addConfirm,
      token,
      restoreInteraction
    } = this.props

    return (
      <Fragment>
        {readOnly('interacoes', token) &&
          !interaction.deletedAt && (
            <IconButton
              onClick={() => {
                fetchInteraction(interaction._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!interaction.deletedAt && findPermission('interacoes', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste a interação?',
                confirmFunction: () => {
                  restoreInteraction(interaction._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('interacoes', token).editar && (
              <IconButton
                onClick={() => {
                  fetchInteraction(interaction._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('interacoes', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão desta interação?',
                    confirmFunction: () => {
                      deleteInteraction(interaction._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const { classes, interactions = [], loadingInteractions, pagination, order = {} } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingInteractions && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
          width={'990px'}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'interacaoTipo_id'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('interacaoTipo_id')
                  }}
                >
                  Interação
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'mdcmnts'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('mdcmnts')
                  }}
                >
                  Medicamentos
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {(interactions || []).length ? (
              (interactions || []).map(interaction => {
                return (
                  <TableRow key={interaction._id}>
                    <TableRowColumn>{(interaction.interacaoTipo_id || {}).nome}</TableRowColumn>
                    <TableRowColumn>
                      {(interaction.mdcmnts || []).map(record => record && record.nome).join(', ')}
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(interaction)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingInteractions ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    interaction: state.interactions.interaction,
    interactions: state.interactions.interactions,
    loadingInteractions: state.interactions.loadingInteractions,
    token: state.auth.token,
    pagination: state.interactions.interactionsPagination,
    order: state.interactions.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(interactionsActions.openModal())
    },
    closeModal: () => {
      dispatch(interactionsActions.closeModal())
    },
    fetchInteraction: id => {
      dispatch(interactionsActions.fetchInteraction(id))
    },
    fetchInteractions: options => {
      dispatch(interactionsActions.fetchInteractions(options))
    },
    deleteInteraction: id => {
      dispatch(interactionsActions.deleteInteraction(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(interactionsActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(interactionsActions.handleChangePerPage(perPage))
    },
    restoreInteraction: id => {
      dispatch(interactionsActions.restoreInteraction(id))
    },
    changeOrderColumn: column => {
      dispatch(interactionsActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(interactionsActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Interactions/ListTable.js